import type { PlanId } from '@tandemone/types'
import { PLAN_IDS, PURCHASABLE_PLAN_IDS } from '@tandemone/types'

import type { CompanyType } from './context'

/* `?plan=` is intent, not entitlement: no payment has happened and no company
 * exists until after email verification. */
export function parsePlanParam(value: string | null): PlanId | null {
  return PLAN_IDS.some(id => id === value) ? (value as PlanId) : null
}

export function companyTypeForPlan(planId: PlanId | null): CompanyType | null {
  if (!planId) return null
  return planId === 'buyer_free' ? 'buyer' : 'supplier'
}

/* someone who clicked "Start with Pro" expects to be asked to pay, so they land
 * on billing with that plan highlighted. free plans follow ?next=. */
export function planDestination(planId: PlanId | null): string | null {
  if (!planId) return null
  const purchasable = PURCHASABLE_PLAN_IDS.some(id => id === planId)
  return purchasable ? `/billing?upgrade=${planId}` : null
}
